import type { CSSObject, Theme } from '@mui/material';
import {
  FORM_FIELD_THEME_NAME,
  V2_FIELD_LABEL_GAP,
  V2_FIELD_LABEL_LINE_HEIGHT,
} from '@onevision-resources/design-theme';

/**
 * Under the v2 theme the Attribute label sits above its field, out of flow, so the rest of the
 * row stays centred on the field box. Only rows that render that label make room for it, so an
 * action row whose field selector has no label keeps its height.
 */
export const getRuleFieldLabelSpaceStyles = (
  theme: Theme,
  {
    combinatorBesideRule,
    leadBesideFirstRule = false,
  }: { combinatorBesideRule: boolean; leadBesideFirstRule?: boolean },
): CSSObject => {
  if (!theme.components?.[FORM_FIELD_THEME_NAME]?.defaultProps?.labelAbove) {
    return {};
  }
  const labelSpace = `calc(${V2_FIELD_LABEL_LINE_HEIGHT} + ${theme.spacing(V2_FIELD_LABEL_GAP)})`;
  const labelledField = '.MuiAutocomplete-root > .MuiFormLabel-root';

  return {
    [`& .rule:has(${labelledField})`]: { paddingTop: labelSpace },
    ...(combinatorBesideRule && {
      [`& .betweenRules:has(+ .rule ${labelledField})`]: { marginTop: labelSpace },
    }),
    ...(leadBesideFirstRule && {
      [`& .ruleGroup-body:has(> .rule:first-of-type ${labelledField})::before`]: {
        paddingTop: labelSpace,
      },
    }),
  };
};
